<script>
	let name = "WTFSIGFD";
	let themeName = "drink";
	let themeColor = "#00ABA6";

</script>


<style>

	.main {
		text-align: center;
		display: flex;
		flex-direction: column;
		/* height: 100%; */
		margin:12px;
	}

	@media only screen and (min-width:768px) {
		.main {
			margin: 24px;
		}
	}

	@media only screen and (min-height: 700px) {
		.main {
			justify-content: center;
		}
	}

	h1 {
		color: #000;
		font-family: "Rajdhani", sans-serif;
		text-transform: uppercase;
		margin-bottom: 0.5em;
		margin-top: 1em;
		text-align: center;
	}

	h2 {
		color: #000;
		font-family: "Rajdhani", sans-serif;
		text-transform: uppercase;
		margin-bottom: 0.5em;
		margin-top: 1em;
		text-align: center;
	}
	p {
		color: #000;
		font-family: "Rajdhani", sans-serif;
		text-transform: uppercase;
		margin-bottom: 0.5em;
		margin-top: 0em;
		text-align: center;

	}

	.copy {
		font-size: 16px;
		text-align: center;
		margin: 8px auto;
		max-width: 60em;
		text-align: left;
	}

	#icon {
		display: inline-block;
		/* border-radius: 24px; */
		margin: 12px auto;
		width: 128px;
	}


</style>

<div class="main">
	<a href="/"><img src="assets/icon.png" alt="{name} app icon" id="icon" /></a>

	
	<div class="copy">
        <h1>TERMS & PRIVACY</h1>
	
<p>This is how we your information is collected, used, and shared when you use {name}.</p>

<h2>PERSONAL INFORMATION WE COLLECT</h2>

<p>When you use {name}, we automatically collect certain information about your device, including information about your IP address and location. </p>

<h2>HOW WE USE YOUR PERSONAL INFORMATION?</h2>

<p>We share your information with third parties to help us show you places to {themeName} near you. Namely, we use Google's Places API to show the most relevant places. As such, by using {name} you will also be bound to Google's <a href="https://policies.google.com/terms?hl=en" class="link"> Terms of Service</a> and <a href="https://policies.google.com/privacy" class="link"> Privacy Policy</a>.</p>

<h2>CHANGES</h2>
<p>
We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.
</p>
<h2>	CONTACT US</h2>
<p>
For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at hello@omakase.studio
	</div>

</div>
